const MAX_CACHE_SIZE = 1000;

const createLRUCache = (maxSize) => {
  const cache = new Map();

  const get = (key) => {
    if (cache.has(key)) {
      const value = cache.get(key);
      cache.delete(key);
      cache.set(key, value);
      return value;
    }
    return undefined;
  };

  const set = (key, value) => {
    if (cache.has(key)) {
      cache.delete(key);
    } else if (cache.size >= maxSize) {
      const firstKey = cache.keys().next().value;
      cache.delete(firstKey);
    }
    cache.set(key, value);
  };

  const has = (key) => cache.has(key);
  const clear = () => cache.clear();
  const deleteKey = (key) => cache.delete(key);
  const getSize = () => cache.size;
  const getKeys = () => cache.keys();
  const getEntries = () => cache.entries();

  return {
    get,
    set,
    has,
    clear,
    delete: deleteKey,
    get size() {
      return getSize();
    },
    keys: getKeys,
    entries: getEntries
  };
};

const lruCache = createLRUCache(MAX_CACHE_SIZE);

function generateCacheKey(params) {
  const cacheKeyObject = {
    resourceId: params.resourceId,
    limit: params.limit,
    page: params.page,
    sort: params.sort,
    filters: params.filters,
    withCount: params.withCount
  };

  const excludedKeys = ['resourceId', 'limit', 'page', 'sort', 'filters', 'withCount'];
  Object.keys(params).forEach((key) => {
    if (!excludedKeys.includes(key)) {
      cacheKeyObject[key] = params[key];
    }
  });

  return JSON.stringify(cacheKeyObject);
}

function clearCache() {
  lruCache.clear();
}

function clearCacheForResource(resourceId) {
  const keysToDelete = [];
  for (const [key] of lruCache.entries()) {
    try {
      const parsedKey = JSON.parse(key);
      if (parsedKey.resourceId === resourceId) {
        keysToDelete.push(key);
      }
    } catch (error) {
      keysToDelete.push(key);
    }
  }
  keysToDelete.forEach((key) => lruCache.delete(key));
}

function getCacheStats() {
  return {
    size: lruCache.size,
    maxSize: MAX_CACHE_SIZE,
    utilization: ((lruCache.size / MAX_CACHE_SIZE) * 100).toFixed(2) + '%'
  };
}

export {
  clearCache,
  clearCacheForResource,
  createLRUCache,
  generateCacheKey,
  getCacheStats,
  lruCache,
  MAX_CACHE_SIZE
};
